var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.386482e-8,
    y1: 77.0019,
    x2: 90,
    y2: 77.0019,
    gradientTransform: "matrix(1 0 0 -1 0 122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02E3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA05D3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.3,42.4c1.5,0,2.6,1.2,2.6,2.6c0,1.5-1.2,2.6-2.6,2.6c-4.6,0-9.1,0-13.7,0c0,4.6,0,9.1,0,13.7 c0,1.5-1.2,2.6-2.6,2.6c-1.5,0-2.6-1.2-2.6-2.6c0-4.6,0-9.1,0-13.7c-4.6,0-9.1,0-13.7,0c-1.5,0-2.6-1.2-2.6-2.6 c0-1.5,1.2-2.6,2.6-2.6c4.6,0,9.1,0,13.7,0c0-4.6,0-9.1,0-13.7c0-1.5,1.2-2.6,2.6-2.6c1.5,0,2.6,1.2,2.6,2.6c0,4.6,0,9.1,0,13.7 C52.2,42.4,56.8,42.4,61.3,42.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 77,
    x2: 89.9999,
    y2: 77,
    gradientTransform: "matrix(1 0 0 -1 0 122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02E3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FA05D3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.3,10.9c17.9,15.4,20.9,42,6.8,60.9C67.1,90.8,40.8,95.6,20.9,83C1,70.3-5.8,44.4,5.4,23.7 c0.7-1.3,2.4-1.8,3.7-1c1.2,0.7,1.6,2.3,0.9,3.5C0.2,44.5,6.1,67.4,23.7,78.5c17.6,11.2,40.8,6.9,53.2-9.9 c12.4-16.7,9.8-40.2-6-53.8C55.1,1.3,31.5,2.2,16.8,17c-1,1-2.6,1-3.6,0.1c-1.1-1-1.2-2.8-0.1-3.8C29.7-3.4,56.4-4.5,74.3,10.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.8ae09fad2bc4d281c00bff336e0bfcdb.svg";
export { ForwardRef as ReactComponent };